import { environment as env } from "../../../environments/environment";

export function filesBaseUrl(): string {
  const basePath = normalizeBasePath(env.rest.basePath ?? "/v1");
  // Only use relative proxy path on localhost local-dev.
  if (!env.production && env.stages?.dev && isLocalDevHost()) {
    return `${basePath}/rest/files`;
  }
  return `${env.rest.protocol}://${env.rest.apiUrl}:${env.rest.port}${basePath}/rest/files`;
}

export function uploadBaseUrl(): string {
  const basePath = normalizeBasePath(env.rest.basePath ?? "/v1");
  const override = env.rest.uploadBaseUrl;
  if (override && override.trim().length > 0) {
    return `${override.replace(/\/$/, "")}${basePath}/rest/files`;
  }
  return filesBaseUrl();
}

export function restBaseUrl(path = ""): string {
  const basePath = normalizeBasePath(env.rest.basePath ?? "/v1");
  const baseUrl = localDevBasePath(`${basePath}/rest`, env.rest);
  return joinPath(baseUrl, path);
}

export function authBaseUrl(path = ""): string {
  const baseUrl = localDevBasePath("/v1/auth", env.auth);
  return joinPath(baseUrl, path);
}

export function restOriginUrl(path = ""): string {
  const baseUrl = !env.production && env.stages?.dev && isLocalDevHost()
    ? ""
    : buildBaseUrl(env.rest);
  return joinPath(baseUrl, path);
}

function joinPath(baseUrl: string, path: string): string {
  if (!path) {
    return baseUrl;
  }
  return `${baseUrl}${path.startsWith("/") ? path : `/${path}`}`;
}

function localDevBasePath(
  proxyPath: string,
  cfg: { apiUrl: string; protocol: string; port?: number }
): string {
  if (!env.production && env.stages?.dev && isLocalDevHost()) {
    return proxyPath;
  }
  return buildBaseUrl(cfg) + proxyPath;
}

function buildBaseUrl(cfg: { apiUrl: string; protocol: string; port?: number }): string {
  const port = cfg.port && cfg.port !== 80 && cfg.port !== 443 ? `:${cfg.port}` : "";
  return `${cfg.protocol}://${cfg.apiUrl}${port}`;
}

function normalizeBasePath(path: string): string {
  const trimmed = path.trim();
  if (!trimmed) return "";
  const withLeading = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return withLeading.replace(/\/$/, "");
}

function isLocalDevHost(): boolean {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname.toLowerCase();
  return host === "localhost" || host === "127.0.0.1";
}
